import "./App.css";
import { Routes, Route } from "react-router-dom";
import { Login } from "./pages/login";
import { PickTenant } from "./pages/pickTenant";

function App() {
  return (
    <>
      <Routes>
        <Route path="" element={<div>None</div>} />
        <Route path="/login" element={<Login />} />
        <Route path="/pick-tenant" element={<PickTenant />} />
      </Routes>
    </>
  );
}

export default App;
